import store from '@/store/index';

export const calculateMLB = () => {

    let result: number = 0;
    let STLB: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    if (GetTuerMass() === 'WW') {
        result = GetMainCharacteristicValue('KTU_MM_MLB');
    } else {
        STLB = GetMainCharacteristicValue('KTU_MM_STLB');
        frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
        frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
        sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
        sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
        blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
        fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

        sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

        const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
        if (selectedWall !== '5') {
            result = STLB + 2 * ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
        } else {
            result = STLB + 2 * ( frameW1 + frameW2 + fermacellW1 );
        }
    }
    return result;
};

export const calculateBMLH = () => {

    let result: number = 0;
    let BSTLH: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    if (GetTuerMass() === 'WW') {
        result = GetMainCharacteristicValue('KTU_MM_BMLH');
    } else {
        BSTLH = GetMainCharacteristicValue('KTU_MM_BSTLH');
        frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
        frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
        sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
        sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
        blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
        fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

        sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

        const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
        if (selectedWall !== '5') {
            result = BSTLH + ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
        } else {
            result = BSTLH + ( frameW1 + frameW2 + fermacellW1 );
        }
    }

    return result;
};

export const calculateGBMLH = () => {

    let result: number = 0;
    let GBSTLH: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    if (GetTuerMass() === 'WW') {
        result = GetMainCharacteristicValue('KTU_MM_GBMLH');
    } else {
        GBSTLH = GetMainCharacteristicValue('KTU_MM_GBSTLH');
        frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
        frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
        sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
        sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
        blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
        fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

        sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

        const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
        if (selectedWall !== '5') {
            result = GBSTLH + ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
        } else {
            result = GBSTLH + ( frameW1 + frameW2 + fermacellW1 );
        }
    }

    return result;
};

export const calculateSTLB = () => {
    let result: number = 0;
    let MLB: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    if (GetTuerMass() === 'FF') {
        result = GetMainCharacteristicValue('KTU_MM_STLB');
    } else {
        MLB = GetMainCharacteristicValue('KTU_MM_MLB');
        frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
        frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
        sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
        sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
        blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
        fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

        sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

        const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
        if (selectedWall !== '5') {
            result = MLB - 2 * ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
        } else {
            result = MLB - 2 * ( frameW1 + frameW2 + fermacellW1 );
        }
    }

    return result;
};

export const calculateBSTLH = () => {

    let result: number = 0;
    let BMLH: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    if (GetTuerMass() === 'FF') {
        result = GetMainCharacteristicValue('KTU_MM_BSTLH');
    } else {
        BMLH = GetMainCharacteristicValue('KTU_MM_BMLH');
        frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
        frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
        sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
        sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
        blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
        fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

        sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

        const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
        if (selectedWall !== '5') {
            result = BMLH - ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
        } else {
            result = BMLH - ( frameW1 + frameW2 + fermacellW1 );
        }
    }

    return result;
};

export const calculateGBSTLH = () => {

    let result: number = 0;
    let GBMLH: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    if (GetTuerMass() === 'FF') {
        result = GetMainCharacteristicValue('KTU_MM_GBSTLH');
    } else {
        GBMLH = GetMainCharacteristicValue('KTU_MM_GBMLH');
        frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
        frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
        sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
        sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
        blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
        fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

        sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

        const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
        if (selectedWall !== '5') {
            result = GBMLH - ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
        } else {
            result = GBMLH - ( frameW1 + frameW2 + fermacellW1 );
        }
    }

    return result;
};

export const calculateDLB90 = () => {

    let result: number = 0;
    let STLB: number = 0;

    STLB = GetMainCharacteristicValue('KTU_MM_STLB');
    const geometrie = GetDependencyValue('KTU_MM_FALZGEOMETRIE', 2);
    const doorWings = GetDependencyValue('KTU_MM_OEFFNUNGSART', 1);

    const falz = geometrie === 'FD' ? 15 : 0;
    const aufdopplungGBS = Number(GetDependencyValue('CUST_MM_AUFDOPPLUNG', 2));

    if (doorWings === 'D1') {
        result = STLB - falz - aufdopplungGBS;
    } else {
        result = STLB - 2 * falz - 2 * aufdopplungGBS;
    }

    return result;
};

export const calculateBDLH = () => {
    let result: number = 0;
    let BMLH: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    BMLH = GetMainCharacteristicValue('KTU_MM_BMLH');
    frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
    frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
    sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
    sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
    blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
    fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

    sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

    const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
    if (selectedWall !== '5') {
        result = BMLH - ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
    } else {
        result = BMLH - ( frameW1 + frameW2 + fermacellW1 );
    }

    return result;
};

export const calculateGBDLH = () => {

    let result: number = 0;
    let GBMLH: number = 0;
    let frameW1: number = 0;
    let frameW2: number = 0;
    let sonderstockW1: number = 0;
    let sonderstockW2: number = 0;
    let sonderstockW: number = 0;
    let blindstockW1: number = 0;
    let fermacellW1: number = 0;

    GBMLH = GetMainCharacteristicValue('KTU_MM_GBMLH');
    frameW1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width1');
    frameW2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'width2');
    sonderstockW1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1');
    sonderstockW2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width2');
    blindstockW1 = GetCharacteristicProperty('KTU_MM_BLINDSTOCK', 'width1');
    fermacellW1 = GetCharacteristicProperty('KTU_MM_FERMACELL', 'width1');

    sonderstockW = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? sonderstockW1 : sonderstockW1 + sonderstockW2;

    const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
    if (selectedWall !== '5') {
        result = GBMLH - ( frameW1 + frameW2 + sonderstockW + blindstockW1 + fermacellW1 );
    } else {
        result = GBMLH - ( frameW1 + frameW2 + fermacellW1 );
    }

    return result;
};

export const calculateBSTMB = () => {
    let result: number = 0;
    let STLB: number = 0;
    let frameH1: number = 0;
    let frameH2: number = 0;
    let sonderstockH1: number = 0;
    let sonderstockW1: number = 0;

    STLB = GetMainCharacteristicValue('KTU_MM_STLB');
    frameH1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height1');
    frameH2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height2');
    sonderstockH1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'height1');
    sonderstockW1 = 0; // GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'width1'); // dont realy know. Delete only

    const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
    if (selectedWall !== '5') {
        result = STLB + 2 * ( frameH1 + frameH2 + sonderstockH1 + sonderstockW1 );
    } else {
        result = STLB + 2 * ( frameH1 + frameH2 );
    }

    return result;
};

export const calculateBSTMH = () => {

    let result: number = 0;
    let BSTLH: number = 0;
    let frameH1: number = 0;
    let frameH2: number = 0;
    let sonderstockH1: number = 0;

    BSTLH = GetMainCharacteristicValue('KTU_MM_BSTLH');
    frameH1 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height1');
    frameH2 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height2');
    sonderstockH1 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'height1');

    const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
    if (selectedWall !== '5') {
        result = BSTLH + ( frameH1 + frameH2 + sonderstockH1 );
    } else {
        result = BSTLH + ( frameH1 + frameH2 );
    }

    return result;
};

export const calculateGBSTMB = () => {

    let result: number = 0;
    let STLB: number = 0;
    let frameH: number = 0;
    let frameH3: number = 0;
    let frameH4: number = 0;
    let sonderstockH2: number = 0;

    STLB = GetMainCharacteristicValue('KTU_MM_STLB');
    frameH3 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height3');
    frameH4 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height4');
    frameH = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? frameH3 : frameH4;
    sonderstockH2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'height2');

    const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);
    if (selectedWall !== '5') {
        result = STLB + 2 * ( frameH + sonderstockH2 );
    } else {
        result = STLB + 2 * ( frameH );
    }

    return result;
};

export const calculateGBSTMH = () => {
    let result: number = 0;
    let GBSTLH: number = 0;
    let GBMLH: number = 0;

    let frameH: number = 0;
    let frameH3: number = 0;
    let frameH4: number = 0;
    let sonderstockH2: number = 0;

    GBSTLH = GetMainCharacteristicValue('KTU_MM_GBSTLH');
    GBMLH = GetMainCharacteristicValue('KTU_MM_GBMLH');

    frameH3 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height3');
    frameH4 = GetCharacteristicProperty('KTU_MM_ZARGE', 'height4');
    frameH = GetDependencyValue('KTU_MM_BLINDSTOCK', 3) !== 'NEIN' ? frameH3 : frameH4;
    sonderstockH2 = GetCharacteristicProperty('KTU_MM_SONDERSTOCK', 'height2');

    const selectedWall = GetDependencyValue('KTU_MM_WANDART_BESTAND', 2);

    if (GetTuerMass() === 'WW') {
        if (selectedWall !== '5') {
            result = GBSTLH + ( frameH + sonderstockH2 );
        } else {
            result = GBSTLH + ( frameH );
        }
    } else {
        if (selectedWall !== '5') {
            result = GBMLH + ( frameH + sonderstockH2 );
        } else {
            result = GBMLH + ( frameH );
        }
    }

    return result;
};

export const calculateNiveauHoehe = () => {
    let result: number = 0;
    let val1: number = 0;
    let val2: number = 0;
    let val3: number = 0;
    let val4: number = 0;


    if (GetTuerMass() === 'WW') {
        result = GetMainCharacteristicValue('KTU_MM_BMLH') - GetMainCharacteristicValue('KTU_MM_GBMLH');
    } else {
        result = GetMainCharacteristicValue('KTU_MM_BSTLH') - GetMainCharacteristicValue('KTU_MM_GBSTLH');
    }

    if (result > 0) {
        const valueObj1 = GetNiveauHoeheValue('A');
        store.getters['configuratorModule/getCurrentDoorConfiguration'].UpdateCharacteristicValueObject(4, 'KTU_MM_NIVEAU_ART', valueObj1);
    } else if (result < 0) {
        const valueObj2 = GetNiveauHoeheValue('B');
        store.getters['configuratorModule/getCurrentDoorConfiguration'].UpdateCharacteristicValueObject(4, 'KTU_MM_NIVEAU_ART', valueObj2);
    } else {
        const valueObj3 = GetNiveauHoeheValue('C');
        store.getters['configuratorModule/getCurrentDoorConfiguration'].UpdateCharacteristicValueObject(4, 'KTU_MM_NIVEAU_ART', valueObj3);
    }

    return Math.abs(result);
};

const GetCharacteristicProperty = (characteristicCode: string, property: string) => {
    let value: number = 0;
    const charcateristicValue = GetCharacteristicValue(characteristicCode);
    const materialValue = GetPropertyValue(charcateristicValue, property);
    value = materialValue;
    return value;
};

const GetCharacteristicValue = (characteristicCode: string) => {
    let characteristicValue;

    const doorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
    const frameCharacteristics = doorConfiguration.Get(3);
    const filteredCharacteristicValue = frameCharacteristics.filter((x: any) => x.code === characteristicCode)[0];

    characteristicValue = filteredCharacteristicValue.value.value;
    return characteristicValue;
};

const GetPropertyValue = (materialCode: string, property: string) => {
    let material: any;
    const materials = store.getters['measureModule/getMaterials'];
    material = typeof materials !== 'undefined' ? materials.filter((x: any) => x.code === materialCode)[0] : undefined;
    const materialProperty = typeof material !== 'undefined' ?  material.childCharacteristics.filter((x: any) => x.property === property)[0] : undefined;
    return typeof materialProperty !== 'undefined' ? materialProperty.value : 0;
};

const GetMainCharacteristicValue = (characteristicCode: string) => {
    let value;

    const doorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
    const frameCharacteristics = doorConfiguration.Get(4);
    const characteristicValue = frameCharacteristics.filter((x: any) => x.code === characteristicCode)[0];
    value = typeof characteristicValue !== 'undefined' ? Number(characteristicValue.value.value) : 0;

    return value;
};

const GetTuerMass = (characteristicCode: string = 'CUST_MM_TUERMASS') => {
    let value;

    const doorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
    const frameCharacteristics = doorConfiguration.Get(4);
    const characteristicValue = frameCharacteristics.filter((x: any) => x.code === characteristicCode)[0];

    if (typeof characteristicValue !== 'undefined') {
        value = characteristicValue.value.value;
    } else {
        value = 'WW';
    }

    return value;
};

const GetDependencyValue = (characteristicCode: string, context: number) => {
    let value;

    const doorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
    const contextCharacteristics = doorConfiguration.Get(context);
    const characteristicValue = contextCharacteristics.filter((x: any) => x.code === characteristicCode)[0];

    if (typeof characteristicValue !== 'undefined') {
        value = characteristicValue.value.value;
    } else {
        value = '0';
    }

    return value;
};

const GetNiveauHoeheValue = (value: string) => {
    const measureCharacteristics = store.getters['measureModule/getMeasureCharacteristics'];
    const niveauHoheChar = measureCharacteristics.filter((x: any) => x.code === 'KTU_MM_NIVEAU_ART')[0];
    const valueObj = niveauHoheChar.values.filter((x: any) => x.value === value)[0];
    return valueObj;
};